import api from '../../../services/api';

interface PurchaseInvoiceParams {
  page?: number;
  page_size?: number;
  search?: string;
  status?: string;
  supplier_id?: number;
  invoice_type?: string;
  date_from?: string;
  date_to?: string;
}

interface PurchaseInvoiceRequest {
  invoice_number: string;
  reference_number?: string;
  supplier_id: number;
  supplier_name?: string;
  supplier_phone?: string;
  warehouse_id?: number;
  invoice_date: string;
  due_date?: string;
  status: string;
  base_currency_id: number;
  foreign_currency_id?: number;
  exchange_rate?: number;
  payment_term_id?: number;
  purchase_order_id?: number;
  total_amount_base: number;
  subtotal_base: number;
  discount_amount_base: number;
  tax_amount_base: number;
  cgst_amount_base: number;
  sgst_amount_base: number;
  igst_amount_base: number;
  ugst_amount_base: number;
  cess_amount_base: number;
  subtotal_foreign?: number;
  discount_amount_foreign?: number;
  tax_amount_foreign?: number;
  total_amount_foreign?: number;
  notes?: string;
  tags?: string[];
  items: Array<{
    line_no: number;
    product_id: number;
    product_name: string;
    quantity: number;
    free_quantity: number;
    uom: string;
    unit_price_base: number;
    unit_price_foreign?: number;
    discount_percent: number;
    discount_amount_base: number;
    discount_amount_foreign?: number;
    taxable_amount_base: number;
    taxable_amount_foreign?: number;
    cgst_rate: number;
    cgst_amount_base: number;
    sgst_rate: number;
    sgst_amount_base: number;
    igst_rate: number;
    igst_amount_base: number;
    ugst_rate?: number;
    ugst_amount_base?: number;
    cess_rate: number;
    cess_amount_base: number;
    tax_amount_base: number;
    tax_amount_foreign?: number;
    total_amount_base: number;
    total_amount_foreign?: number;
    hsn_code?: string;
    batch_number?: string;
    description?: string;
  }>;
}

class PurchaseInvoiceService {
  async getPurchaseInvoices(params: PurchaseInvoiceParams = {}): Promise<any> {
    try {
      const response = await api.get('/api/v1/inventory/purchase-invoices', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getPurchaseInvoice(invoiceId: number): Promise<any> {
    try {
      const response = await api.get(`/api/v1/inventory/purchase-invoices/${invoiceId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createPurchaseInvoice(data: PurchaseInvoiceRequest): Promise<any> {
    try {
      const response = await api.post('/api/v1/inventory/purchase-invoices', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updatePurchaseInvoice(invoiceId: number, data: PurchaseInvoiceRequest): Promise<any> {
    try {
      const response = await api.put(`/api/v1/inventory/purchase-invoices/${invoiceId}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deletePurchaseInvoice(invoiceId: number): Promise<any> {
    try {
      const response = await api.delete(`/api/v1/inventory/purchase-invoices/${invoiceId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async recordPayment(invoiceId: number, paymentAmount: number): Promise<any> {
    try {
      const response = await api.post(
        `/api/v1/inventory/purchase-invoices/${invoiceId}/payment`,
        {},
        { params: { payment_amount: paymentAmount } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const purchaseInvoiceService = new PurchaseInvoiceService();
